import { create } from 'zustand';

interface SupportWidgetStore {
  open: boolean;
  pendingMessage: string | null;
  feedbackPopoverOpen: boolean;
  toggleOpen: () => void;
  openWithMessage: (message: string) => void;
  toggleOrOpenWithMessage: (message: string) => void;
  clearPendingMessage: () => void;
  setFeedbackPopoverOpen: (open: boolean) => void;
}

export const useSupportWidgetStore = create<SupportWidgetStore>((set) => ({
  open: false,
  pendingMessage: null,
  feedbackPopoverOpen: false,
  toggleOpen: () => set(({ open }) => ({ open: !open })),
  openWithMessage: (message: string) => set({ open: true, pendingMessage: message }),
  toggleOrOpenWithMessage: (message: string) =>
    set(({ open }) => (open ? { open: false } : { open: true, pendingMessage: message })),
  clearPendingMessage: () => set({ pendingMessage: null }),
  setFeedbackPopoverOpen: (open: boolean) => set({ feedbackPopoverOpen: open }),
}));
